/* eslint-disable */

// @ts-nocheck

// Auto-generated route tree for DIKDOC_HUB v7.2

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/'
import { Route as adminAdministrateurRouteImport } from './routes/admin/administrateur'
import { Route as adminAdministrateurConsultationsRouteImport } from './routes/admin/administrateur/consultations'
import { Route as adminAdministrateurFacturationCodageRouteImport } from './routes/admin/administrateur/facturation/codage'
import { Route as adminAdministrateurIaModel_registryRouteImport } from './routes/admin/administrateur/ia/model-registry'
import { Route as adminAdministrateurImagingIaRouteImport } from './routes/admin/administrateur/imaging/ia'
import { Route as adminAdministrateurImagingPacsRouteImport } from './routes/admin/administrateur/imaging/pacs'
import { Route as adminAdministrateurImagingStoreRouteImport } from './routes/admin/administrateur/imaging/store'
import { Route as adminAdministrateurImagingWorklistsRouteImport } from './routes/admin/administrateur/imaging/worklists'
import { Route as adminAdministrateurIntegrationIhe_gwRouteImport } from './routes/admin/administrateur/integration/ihe-gw'
import { Route as adminAdministrateurIntegrationObservationsRouteImport } from './routes/admin/administrateur/integration/observations'
import { Route as adminAdministrateurIntegrationPacs_gwRouteImport } from './routes/admin/administrateur/integration/pacs-gw'
import { Route as adminAdministrateurLabAnalyseursRouteImport } from './routes/admin/administrateur/lab/analyseurs'
import { Route as adminAdministrateurLabMiddlewareRouteImport } from './routes/admin/administrateur/lab/middleware'
import { Route as adminAdministrateurLabResultatsRouteImport } from './routes/admin/administrateur/lab/resultats'
import { Route as adminAdministrateurPharmaDispensationRouteImport } from './routes/admin/administrateur/pharma/dispensation'
import { Route as adminAdministrateurPharmaStocksRouteImport } from './routes/admin/administrateur/pharma/stocks'
import { Route as adminAdministrateurPharmaTracabiliteRouteImport } from './routes/admin/administrateur/pharma/tracabilite'
import { Route as adminAuditRouteImport } from './routes/admin/audit'
import { Route as adminConsultationsRouteImport } from './routes/admin/consultations'
import { Route as adminDoctor_cotationsRouteImport } from './routes/admin/doctor-cotations'
import { Route as adminDoctorsRouteImport } from './routes/admin/doctors'
import { Route as adminMachinesRouteImport } from './routes/admin/machines'
import { Route as adminSettingsRouteImport } from './routes/admin/settings'
import { Route as adminSiemRouteImport } from './routes/admin/siem'
import { Route as adminSiemConformiteFdaRouteImport } from './routes/admin/siem/conformite/fda'
import { Route as adminSiemConformiteHipaa_gdprRouteImport } from './routes/admin/siem/conformite/hipaa-gdpr'
import { Route as adminSiemConformiteIec_62304RouteImport } from './routes/admin/siem/conformite/iec-62304'
import { Route as adminSiemConformiteIso_14971RouteImport } from './routes/admin/siem/conformite/iso-14971'
import { Route as adminSiemGouvernanceEtablissementsRouteImport } from './routes/admin/siem/gouvernance/etablissements'
import { Route as adminSiemGouvernanceRegulatory_ledgerRouteImport } from './routes/admin/siem/gouvernance/regulatory-ledger'
import { Route as adminSiemInfrastructureArgocdRouteImport } from './routes/admin/siem/infrastructure/argocd'
import { Route as adminSiemInfrastructureKafkaRouteImport } from './routes/admin/siem/infrastructure/kafka'
import { Route as adminSiemInfrastructureKubernetesRouteImport } from './routes/admin/siem/infrastructure/kubernetes'
import { Route as adminSiemInfrastructurePostgresqlRouteImport } from './routes/admin/siem/infrastructure/postgresql'
import { Route as adminSiemInfrastructureRedisRouteImport } from './routes/admin/siem/infrastructure/redis'
import { Route as adminSiemInfrastructureVaultRouteImport } from './routes/admin/siem/infrastructure/vault'
import { Route as adminSiemNotificationsRouteImport } from './routes/admin/siem/notifications'
import { Route as adminSiemObservabiliteAlertmanagerRouteImport } from './routes/admin/siem/observabilite/alertmanager'
import { Route as adminSiemObservabiliteGrafanaRouteImport } from './routes/admin/siem/observabilite/grafana'
import { Route as adminSiemObservabiliteLokiRouteImport } from './routes/admin/siem/observabilite/loki'
import { Route as adminSiemObservabilitePrometheusRouteImport } from './routes/admin/siem/observabilite/prometheus'
import { Route as adminSiemObservabiliteSloRouteImport } from './routes/admin/siem/observabilite/slo'
import { Route as adminUsersRouteImport } from './routes/admin/users'
import { Route as aiRouteImport } from './routes/ai'
import { Route as aiClinical_notesRouteImport } from './routes/ai/clinical-notes'
import { Route as aiDrug_interactionsRouteImport } from './routes/ai/drug-interactions'
import { Route as aiIcd10_advisorRouteImport } from './routes/ai/icd10-advisor'
import { Route as aldRouteImport } from './routes/ald'
import { Route as billingRouteImport } from './routes/billing'
import { Route as catalogDevicesRouteImport } from './routes/catalog/devices'
import { Route as catalogMedicationsRouteImport } from './routes/catalog/medications'
import { Route as catalogsRouteImport } from './routes/catalogs'
import { Route as claimsRouteImport } from './routes/claims'
import { Route as claimsIdRouteImport } from './routes/claims/$id'
import { Route as claimsNewRouteImport } from './routes/claims/new'
import { Route as cockpitsRouteImport } from './routes/cockpits'
import { Route as consultationRouteImport } from './routes/consultation'
import { Route as dashboardRouteImport } from './routes/dashboard'
import { Route as e_notesRouteImport } from './routes/e-notes'
import { Route as governancePoliciesRouteImport } from './routes/governance/policies'
import { Route as governanceWorkflowsRouteImport } from './routes/governance/workflows'
import { Route as integrationConnectivity_testsRouteImport } from './routes/integration/connectivity-tests'
import { Route as integrationDevice_certificationRouteImport } from './routes/integration/device-certification'
import { Route as integrationDevice_profilesRouteImport } from './routes/integration/device-profiles'
import { Route as integrationDevice_profiles_adminRouteImport } from './routes/integration/device-profiles-admin'
import { Route as integrationDevice_registryRouteImport } from './routes/integration/device-registry'
import { Route as integrationDevice_simulatorRouteImport } from './routes/integration/device-simulator'
import { Route as integrationImagingRouteImport } from './routes/integration/imaging'
import { Route as integrationObservationsRouteImport } from './routes/integration/observations'
import { Route as integrationProfilesRouteImport } from './routes/integration/profiles'
import { Route as lab_resultsRouteImport } from './routes/lab-results'
import { Route as loginRouteImport } from './routes/login'
import { Route as operationsRouteImport } from './routes/operations'
import { Route as patientsRouteImport } from './routes/patients'
import { Route as patientsPatientIdRouteImport } from './routes/patients/$patientId'
import { Route as pharmacyRouteImport } from './routes/pharmacy'
import { Route as prescriptionRouteImport } from './routes/prescription'
import { Route as radiologyRouteImport } from './routes/radiology'
import { Route as referentialAldRouteImport } from './routes/referential/ald'
import { Route as referentialCim10RouteImport } from './routes/referential/cim10'
import { Route as referentialCnssRouteImport } from './routes/referential/cnss'
import { Route as referentialForfaitsRouteImport } from './routes/referential/forfaits'
import { Route as referentialLoincRouteImport } from './routes/referential/loinc'
import { Route as referentialMedicationsRouteImport } from './routes/referential/medications'
import { Route as referentialNgapRouteImport } from './routes/referential/ngap'
import { Route as referentialRulesRouteImport } from './routes/referential/rules'
import { Route as referentialSnomedRouteImport } from './routes/referential/snomed'
import { Route as securityKeysRouteImport } from './routes/security/keys'
import { Route as securitySecretsRouteImport } from './routes/security/secrets'
import { Route as socRouteImport } from './routes/soc'


const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)

const adminAdministrateurRoute = adminAdministrateurRouteImport.update({
  id: '/admin/administrateur',
  path: '/admin/administrateur',
  getParentRoute: () => rootRouteImport,
} as any)

const adminAdministrateurConsultationsRoute = adminAdministrateurConsultationsRouteImport.update({
  id: '/admin/administrateur/consultations',
  path: '/admin/administrateur/consultations',
  getParentRoute: () => rootRouteImport,
} as any)

const adminAdministrateurFacturationCodageRoute = adminAdministrateurFacturationCodageRouteImport.update({
  id: '/admin/administrateur/facturation/codage',
  path: '/admin/administrateur/facturation/codage',
  getParentRoute: () => rootRouteImport,
} as any)

const adminAdministrateurIaModel_registryRoute = adminAdministrateurIaModel_registryRouteImport.update({
  id: '/admin/administrateur/ia/model-registry',
  path: '/admin/administrateur/ia/model-registry',
  getParentRoute: () => rootRouteImport,
} as any)

const adminAdministrateurImagingIaRoute = adminAdministrateurImagingIaRouteImport.update({
  id: '/admin/administrateur/imaging/ia',
  path: '/admin/administrateur/imaging/ia',
  getParentRoute: () => rootRouteImport,
} as any)

const adminAdministrateurImagingPacsRoute = adminAdministrateurImagingPacsRouteImport.update({
  id: '/admin/administrateur/imaging/pacs',
  path: '/admin/administrateur/imaging/pacs',
  getParentRoute: () => rootRouteImport,
} as any)

const adminAdministrateurImagingStoreRoute = adminAdministrateurImagingStoreRouteImport.update({
  id: '/admin/administrateur/imaging/store',
  path: '/admin/administrateur/imaging/store',
  getParentRoute: () => rootRouteImport,
} as any)

const adminAdministrateurImagingWorklistsRoute = adminAdministrateurImagingWorklistsRouteImport.update({
  id: '/admin/administrateur/imaging/worklists',
  path: '/admin/administrateur/imaging/worklists',
  getParentRoute: () => rootRouteImport,
} as any)

const adminAdministrateurIntegrationIhe_gwRoute = adminAdministrateurIntegrationIhe_gwRouteImport.update({
  id: '/admin/administrateur/integration/ihe-gw',
  path: '/admin/administrateur/integration/ihe-gw',
  getParentRoute: () => rootRouteImport,
} as any)

const adminAdministrateurIntegrationObservationsRoute = adminAdministrateurIntegrationObservationsRouteImport.update({
  id: '/admin/administrateur/integration/observations',
  path: '/admin/administrateur/integration/observations',
  getParentRoute: () => rootRouteImport,
} as any)

const adminAdministrateurIntegrationPacs_gwRoute = adminAdministrateurIntegrationPacs_gwRouteImport.update({
  id: '/admin/administrateur/integration/pacs-gw',
  path: '/admin/administrateur/integration/pacs-gw',
  getParentRoute: () => rootRouteImport,
} as any)

const adminAdministrateurLabAnalyseursRoute = adminAdministrateurLabAnalyseursRouteImport.update({
  id: '/admin/administrateur/lab/analyseurs',
  path: '/admin/administrateur/lab/analyseurs',
  getParentRoute: () => rootRouteImport,
} as any)

const adminAdministrateurLabMiddlewareRoute = adminAdministrateurLabMiddlewareRouteImport.update({
  id: '/admin/administrateur/lab/middleware',
  path: '/admin/administrateur/lab/middleware',
  getParentRoute: () => rootRouteImport,
} as any)

const adminAdministrateurLabResultatsRoute = adminAdministrateurLabResultatsRouteImport.update({
  id: '/admin/administrateur/lab/resultats',
  path: '/admin/administrateur/lab/resultats',
  getParentRoute: () => rootRouteImport,
} as any)

const adminAdministrateurPharmaDispensationRoute = adminAdministrateurPharmaDispensationRouteImport.update({
  id: '/admin/administrateur/pharma/dispensation',
  path: '/admin/administrateur/pharma/dispensation',
  getParentRoute: () => rootRouteImport,
} as any)

const adminAdministrateurPharmaStocksRoute = adminAdministrateurPharmaStocksRouteImport.update({
  id: '/admin/administrateur/pharma/stocks',
  path: '/admin/administrateur/pharma/stocks',
  getParentRoute: () => rootRouteImport,
} as any)

const adminAdministrateurPharmaTracabiliteRoute = adminAdministrateurPharmaTracabiliteRouteImport.update({
  id: '/admin/administrateur/pharma/tracabilite',
  path: '/admin/administrateur/pharma/tracabilite',
  getParentRoute: () => rootRouteImport,
} as any)

const adminAuditRoute = adminAuditRouteImport.update({
  id: '/admin/audit',
  path: '/admin/audit',
  getParentRoute: () => rootRouteImport,
} as any)

const adminConsultationsRoute = adminConsultationsRouteImport.update({
  id: '/admin/consultations',
  path: '/admin/consultations',
  getParentRoute: () => rootRouteImport,
} as any)

const adminDoctor_cotationsRoute = adminDoctor_cotationsRouteImport.update({
  id: '/admin/doctor-cotations',
  path: '/admin/doctor-cotations',
  getParentRoute: () => rootRouteImport,
} as any)

const adminDoctorsRoute = adminDoctorsRouteImport.update({
  id: '/admin/doctors',
  path: '/admin/doctors',
  getParentRoute: () => rootRouteImport,
} as any)

const adminMachinesRoute = adminMachinesRouteImport.update({
  id: '/admin/machines',
  path: '/admin/machines',
  getParentRoute: () => rootRouteImport,
} as any)

const adminSettingsRoute = adminSettingsRouteImport.update({
  id: '/admin/settings',
  path: '/admin/settings',
  getParentRoute: () => rootRouteImport,
} as any)

const adminSiemRoute = adminSiemRouteImport.update({
  id: '/admin/siem',
  path: '/admin/siem',
  getParentRoute: () => rootRouteImport,
} as any)

const adminSiemConformiteFdaRoute = adminSiemConformiteFdaRouteImport.update({
  id: '/admin/siem/conformite/fda',
  path: '/admin/siem/conformite/fda',
  getParentRoute: () => rootRouteImport,
} as any)

const adminSiemConformiteHipaa_gdprRoute = adminSiemConformiteHipaa_gdprRouteImport.update({
  id: '/admin/siem/conformite/hipaa-gdpr',
  path: '/admin/siem/conformite/hipaa-gdpr',
  getParentRoute: () => rootRouteImport,
} as any)

const adminSiemConformiteIec_62304Route = adminSiemConformiteIec_62304RouteImport.update({
  id: '/admin/siem/conformite/iec-62304',
  path: '/admin/siem/conformite/iec-62304',
  getParentRoute: () => rootRouteImport,
} as any)

const adminSiemConformiteIso_14971Route = adminSiemConformiteIso_14971RouteImport.update({
  id: '/admin/siem/conformite/iso-14971',
  path: '/admin/siem/conformite/iso-14971',
  getParentRoute: () => rootRouteImport,
} as any)

const adminSiemGouvernanceEtablissementsRoute = adminSiemGouvernanceEtablissementsRouteImport.update({
  id: '/admin/siem/gouvernance/etablissements',
  path: '/admin/siem/gouvernance/etablissements',
  getParentRoute: () => rootRouteImport,
} as any)

const adminSiemGouvernanceRegulatory_ledgerRoute = adminSiemGouvernanceRegulatory_ledgerRouteImport.update({
  id: '/admin/siem/gouvernance/regulatory-ledger',
  path: '/admin/siem/gouvernance/regulatory-ledger',
  getParentRoute: () => rootRouteImport,
} as any)

const adminSiemInfrastructureArgocdRoute = adminSiemInfrastructureArgocdRouteImport.update({
  id: '/admin/siem/infrastructure/argocd',
  path: '/admin/siem/infrastructure/argocd',
  getParentRoute: () => rootRouteImport,
} as any)

const adminSiemInfrastructureKafkaRoute = adminSiemInfrastructureKafkaRouteImport.update({
  id: '/admin/siem/infrastructure/kafka',
  path: '/admin/siem/infrastructure/kafka',
  getParentRoute: () => rootRouteImport,
} as any)

const adminSiemInfrastructureKubernetesRoute = adminSiemInfrastructureKubernetesRouteImport.update({
  id: '/admin/siem/infrastructure/kubernetes',
  path: '/admin/siem/infrastructure/kubernetes',
  getParentRoute: () => rootRouteImport,
} as any)

const adminSiemInfrastructurePostgresqlRoute = adminSiemInfrastructurePostgresqlRouteImport.update({
  id: '/admin/siem/infrastructure/postgresql',
  path: '/admin/siem/infrastructure/postgresql',
  getParentRoute: () => rootRouteImport,
} as any)

const adminSiemInfrastructureRedisRoute = adminSiemInfrastructureRedisRouteImport.update({
  id: '/admin/siem/infrastructure/redis',
  path: '/admin/siem/infrastructure/redis',
  getParentRoute: () => rootRouteImport,
} as any)

const adminSiemInfrastructureVaultRoute = adminSiemInfrastructureVaultRouteImport.update({
  id: '/admin/siem/infrastructure/vault',
  path: '/admin/siem/infrastructure/vault',
  getParentRoute: () => rootRouteImport,
} as any)

const adminSiemNotificationsRoute = adminSiemNotificationsRouteImport.update({
  id: '/admin/siem/notifications',
  path: '/admin/siem/notifications',
  getParentRoute: () => rootRouteImport,
} as any)

const adminSiemObservabiliteAlertmanagerRoute = adminSiemObservabiliteAlertmanagerRouteImport.update({
  id: '/admin/siem/observabilite/alertmanager',
  path: '/admin/siem/observabilite/alertmanager',
  getParentRoute: () => rootRouteImport,
} as any)

const adminSiemObservabiliteGrafanaRoute = adminSiemObservabiliteGrafanaRouteImport.update({
  id: '/admin/siem/observabilite/grafana',
  path: '/admin/siem/observabilite/grafana',
  getParentRoute: () => rootRouteImport,
} as any)

const adminSiemObservabiliteLokiRoute = adminSiemObservabiliteLokiRouteImport.update({
  id: '/admin/siem/observabilite/loki',
  path: '/admin/siem/observabilite/loki',
  getParentRoute: () => rootRouteImport,
} as any)

const adminSiemObservabilitePrometheusRoute = adminSiemObservabilitePrometheusRouteImport.update({
  id: '/admin/siem/observabilite/prometheus',
  path: '/admin/siem/observabilite/prometheus',
  getParentRoute: () => rootRouteImport,
} as any)

const adminSiemObservabiliteSloRoute = adminSiemObservabiliteSloRouteImport.update({
  id: '/admin/siem/observabilite/slo',
  path: '/admin/siem/observabilite/slo',
  getParentRoute: () => rootRouteImport,
} as any)

const adminUsersRoute = adminUsersRouteImport.update({
  id: '/admin/users',
  path: '/admin/users',
  getParentRoute: () => rootRouteImport,
} as any)

const aiRoute = aiRouteImport.update({
  id: '/ai',
  path: '/ai',
  getParentRoute: () => rootRouteImport,
} as any)

const aiClinical_notesRoute = aiClinical_notesRouteImport.update({
  id: '/ai/clinical-notes',
  path: '/ai/clinical-notes',
  getParentRoute: () => rootRouteImport,
} as any)

const aiDrug_interactionsRoute = aiDrug_interactionsRouteImport.update({
  id: '/ai/drug-interactions',
  path: '/ai/drug-interactions',
  getParentRoute: () => rootRouteImport,
} as any)

const aiIcd10_advisorRoute = aiIcd10_advisorRouteImport.update({
  id: '/ai/icd10-advisor',
  path: '/ai/icd10-advisor',
  getParentRoute: () => rootRouteImport,
} as any)

const aldRoute = aldRouteImport.update({
  id: '/ald',
  path: '/ald',
  getParentRoute: () => rootRouteImport,
} as any)

const billingRoute = billingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => rootRouteImport,
} as any)

const catalogDevicesRoute = catalogDevicesRouteImport.update({
  id: '/catalog/devices',
  path: '/catalog/devices',
  getParentRoute: () => rootRouteImport,
} as any)

const catalogMedicationsRoute = catalogMedicationsRouteImport.update({
  id: '/catalog/medications',
  path: '/catalog/medications',
  getParentRoute: () => rootRouteImport,
} as any)

const catalogsRoute = catalogsRouteImport.update({
  id: '/catalogs',
  path: '/catalogs',
  getParentRoute: () => rootRouteImport,
} as any)

const claimsRoute = claimsRouteImport.update({
  id: '/claims',
  path: '/claims',
  getParentRoute: () => rootRouteImport,
} as any)

const claimsIdRoute = claimsIdRouteImport.update({
  id: '/claims/$id',
  path: '/claims/$id',
  getParentRoute: () => rootRouteImport,
} as any)

const claimsNewRoute = claimsNewRouteImport.update({
  id: '/claims/new',
  path: '/claims/new',
  getParentRoute: () => rootRouteImport,
} as any)

const cockpitsRoute = cockpitsRouteImport.update({
  id: '/cockpits',
  path: '/cockpits',
  getParentRoute: () => rootRouteImport,
} as any)

const consultationRoute = consultationRouteImport.update({
  id: '/consultation',
  path: '/consultation',
  getParentRoute: () => rootRouteImport,
} as any)

const dashboardRoute = dashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)

const e_notesRoute = e_notesRouteImport.update({
  id: '/e-notes',
  path: '/e-notes',
  getParentRoute: () => rootRouteImport,
} as any)

const governancePoliciesRoute = governancePoliciesRouteImport.update({
  id: '/governance/policies',
  path: '/governance/policies',
  getParentRoute: () => rootRouteImport,
} as any)

const governanceWorkflowsRoute = governanceWorkflowsRouteImport.update({
  id: '/governance/workflows',
  path: '/governance/workflows',
  getParentRoute: () => rootRouteImport,
} as any)

const integrationConnectivity_testsRoute = integrationConnectivity_testsRouteImport.update({
  id: '/integration/connectivity-tests',
  path: '/integration/connectivity-tests',
  getParentRoute: () => rootRouteImport,
} as any)

const integrationDevice_certificationRoute = integrationDevice_certificationRouteImport.update({
  id: '/integration/device-certification',
  path: '/integration/device-certification',
  getParentRoute: () => rootRouteImport,
} as any)

const integrationDevice_profilesRoute = integrationDevice_profilesRouteImport.update({
  id: '/integration/device-profiles',
  path: '/integration/device-profiles',
  getParentRoute: () => rootRouteImport,
} as any)

const integrationDevice_profiles_adminRoute = integrationDevice_profiles_adminRouteImport.update({
  id: '/integration/device-profiles-admin',
  path: '/integration/device-profiles-admin',
  getParentRoute: () => rootRouteImport,
} as any)

const integrationDevice_registryRoute = integrationDevice_registryRouteImport.update({
  id: '/integration/device-registry',
  path: '/integration/device-registry',
  getParentRoute: () => rootRouteImport,
} as any)

const integrationDevice_simulatorRoute = integrationDevice_simulatorRouteImport.update({
  id: '/integration/device-simulator',
  path: '/integration/device-simulator',
  getParentRoute: () => rootRouteImport,
} as any)

const integrationImagingRoute = integrationImagingRouteImport.update({
  id: '/integration/imaging',
  path: '/integration/imaging',
  getParentRoute: () => rootRouteImport,
} as any)

const integrationObservationsRoute = integrationObservationsRouteImport.update({
  id: '/integration/observations',
  path: '/integration/observations',
  getParentRoute: () => rootRouteImport,
} as any)

const integrationProfilesRoute = integrationProfilesRouteImport.update({
  id: '/integration/profiles',
  path: '/integration/profiles',
  getParentRoute: () => rootRouteImport,
} as any)

const lab_resultsRoute = lab_resultsRouteImport.update({
  id: '/lab-results',
  path: '/lab-results',
  getParentRoute: () => rootRouteImport,
} as any)

const loginRoute = loginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)

const operationsRoute = operationsRouteImport.update({
  id: '/operations',
  path: '/operations',
  getParentRoute: () => rootRouteImport,
} as any)

const patientsRoute = patientsRouteImport.update({
  id: '/patients',
  path: '/patients',
  getParentRoute: () => rootRouteImport,
} as any)

const patientsPatientIdRoute = patientsPatientIdRouteImport.update({
  id: '/patients/$patientId',
  path: '/patients/$patientId',
  getParentRoute: () => rootRouteImport,
} as any)

const pharmacyRoute = pharmacyRouteImport.update({
  id: '/pharmacy',
  path: '/pharmacy',
  getParentRoute: () => rootRouteImport,
} as any)

const prescriptionRoute = prescriptionRouteImport.update({
  id: '/prescription',
  path: '/prescription',
  getParentRoute: () => rootRouteImport,
} as any)

const radiologyRoute = radiologyRouteImport.update({
  id: '/radiology',
  path: '/radiology',
  getParentRoute: () => rootRouteImport,
} as any)

const referentialAldRoute = referentialAldRouteImport.update({
  id: '/referential/ald',
  path: '/referential/ald',
  getParentRoute: () => rootRouteImport,
} as any)

const referentialCim10Route = referentialCim10RouteImport.update({
  id: '/referential/cim10',
  path: '/referential/cim10',
  getParentRoute: () => rootRouteImport,
} as any)

const referentialCnssRoute = referentialCnssRouteImport.update({
  id: '/referential/cnss',
  path: '/referential/cnss',
  getParentRoute: () => rootRouteImport,
} as any)

const referentialForfaitsRoute = referentialForfaitsRouteImport.update({
  id: '/referential/forfaits',
  path: '/referential/forfaits',
  getParentRoute: () => rootRouteImport,
} as any)

const referentialLoincRoute = referentialLoincRouteImport.update({
  id: '/referential/loinc',
  path: '/referential/loinc',
  getParentRoute: () => rootRouteImport,
} as any)

const referentialMedicationsRoute = referentialMedicationsRouteImport.update({
  id: '/referential/medications',
  path: '/referential/medications',
  getParentRoute: () => rootRouteImport,
} as any)

const referentialNgapRoute = referentialNgapRouteImport.update({
  id: '/referential/ngap',
  path: '/referential/ngap',
  getParentRoute: () => rootRouteImport,
} as any)

const referentialRulesRoute = referentialRulesRouteImport.update({
  id: '/referential/rules',
  path: '/referential/rules',
  getParentRoute: () => rootRouteImport,
} as any)

const referentialSnomedRoute = referentialSnomedRouteImport.update({
  id: '/referential/snomed',
  path: '/referential/snomed',
  getParentRoute: () => rootRouteImport,
} as any)

const securityKeysRoute = securityKeysRouteImport.update({
  id: '/security/keys',
  path: '/security/keys',
  getParentRoute: () => rootRouteImport,
} as any)

const securitySecretsRoute = securitySecretsRouteImport.update({
  id: '/security/secrets',
  path: '/security/secrets',
  getParentRoute: () => rootRouteImport,
} as any)

const socRoute = socRouteImport.update({
  id: '/soc',
  path: '/soc',
  getParentRoute: () => rootRouteImport,
} as any)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  adminAdministrateurRoute: adminAdministrateurRoute,
  adminAdministrateurConsultationsRoute: adminAdministrateurConsultationsRoute,
  adminAdministrateurFacturationCodageRoute: adminAdministrateurFacturationCodageRoute,
  adminAdministrateurIaModel_registryRoute: adminAdministrateurIaModel_registryRoute,
  adminAdministrateurImagingIaRoute: adminAdministrateurImagingIaRoute,
  adminAdministrateurImagingPacsRoute: adminAdministrateurImagingPacsRoute,
  adminAdministrateurImagingStoreRoute: adminAdministrateurImagingStoreRoute,
  adminAdministrateurImagingWorklistsRoute: adminAdministrateurImagingWorklistsRoute,
  adminAdministrateurIntegrationIhe_gwRoute: adminAdministrateurIntegrationIhe_gwRoute,
  adminAdministrateurIntegrationObservationsRoute: adminAdministrateurIntegrationObservationsRoute,
  adminAdministrateurIntegrationPacs_gwRoute: adminAdministrateurIntegrationPacs_gwRoute,
  adminAdministrateurLabAnalyseursRoute: adminAdministrateurLabAnalyseursRoute,
  adminAdministrateurLabMiddlewareRoute: adminAdministrateurLabMiddlewareRoute,
  adminAdministrateurLabResultatsRoute: adminAdministrateurLabResultatsRoute,
  adminAdministrateurPharmaDispensationRoute: adminAdministrateurPharmaDispensationRoute,
  adminAdministrateurPharmaStocksRoute: adminAdministrateurPharmaStocksRoute,
  adminAdministrateurPharmaTracabiliteRoute: adminAdministrateurPharmaTracabiliteRoute,
  adminAuditRoute: adminAuditRoute,
  adminConsultationsRoute: adminConsultationsRoute,
  adminDoctor_cotationsRoute: adminDoctor_cotationsRoute,
  adminDoctorsRoute: adminDoctorsRoute,
  adminMachinesRoute: adminMachinesRoute,
  adminSettingsRoute: adminSettingsRoute,
  adminSiemRoute: adminSiemRoute,
  adminSiemConformiteFdaRoute: adminSiemConformiteFdaRoute,
  adminSiemConformiteHipaa_gdprRoute: adminSiemConformiteHipaa_gdprRoute,
  adminSiemConformiteIec_62304Route: adminSiemConformiteIec_62304Route,
  adminSiemConformiteIso_14971Route: adminSiemConformiteIso_14971Route,
  adminSiemGouvernanceEtablissementsRoute: adminSiemGouvernanceEtablissementsRoute,
  adminSiemGouvernanceRegulatory_ledgerRoute: adminSiemGouvernanceRegulatory_ledgerRoute,
  adminSiemInfrastructureArgocdRoute: adminSiemInfrastructureArgocdRoute,
  adminSiemInfrastructureKafkaRoute: adminSiemInfrastructureKafkaRoute,
  adminSiemInfrastructureKubernetesRoute: adminSiemInfrastructureKubernetesRoute,
  adminSiemInfrastructurePostgresqlRoute: adminSiemInfrastructurePostgresqlRoute,
  adminSiemInfrastructureRedisRoute: adminSiemInfrastructureRedisRoute,
  adminSiemInfrastructureVaultRoute: adminSiemInfrastructureVaultRoute,
  adminSiemNotificationsRoute: adminSiemNotificationsRoute,
  adminSiemObservabiliteAlertmanagerRoute: adminSiemObservabiliteAlertmanagerRoute,
  adminSiemObservabiliteGrafanaRoute: adminSiemObservabiliteGrafanaRoute,
  adminSiemObservabiliteLokiRoute: adminSiemObservabiliteLokiRoute,
  adminSiemObservabilitePrometheusRoute: adminSiemObservabilitePrometheusRoute,
  adminSiemObservabiliteSloRoute: adminSiemObservabiliteSloRoute,
  adminUsersRoute: adminUsersRoute,
  aiRoute: aiRoute,
  aiClinical_notesRoute: aiClinical_notesRoute,
  aiDrug_interactionsRoute: aiDrug_interactionsRoute,
  aiIcd10_advisorRoute: aiIcd10_advisorRoute,
  aldRoute: aldRoute,
  billingRoute: billingRoute,
  catalogDevicesRoute: catalogDevicesRoute,
  catalogMedicationsRoute: catalogMedicationsRoute,
  catalogsRoute: catalogsRoute,
  claimsRoute: claimsRoute,
  claimsIdRoute: claimsIdRoute,
  claimsNewRoute: claimsNewRoute,
  cockpitsRoute: cockpitsRoute,
  consultationRoute: consultationRoute,
  dashboardRoute: dashboardRoute,
  e_notesRoute: e_notesRoute,
  governancePoliciesRoute: governancePoliciesRoute,
  governanceWorkflowsRoute: governanceWorkflowsRoute,
  integrationConnectivity_testsRoute: integrationConnectivity_testsRoute,
  integrationDevice_certificationRoute: integrationDevice_certificationRoute,
  integrationDevice_profilesRoute: integrationDevice_profilesRoute,
  integrationDevice_profiles_adminRoute: integrationDevice_profiles_adminRoute,
  integrationDevice_registryRoute: integrationDevice_registryRoute,
  integrationDevice_simulatorRoute: integrationDevice_simulatorRoute,
  integrationImagingRoute: integrationImagingRoute,
  integrationObservationsRoute: integrationObservationsRoute,
  integrationProfilesRoute: integrationProfilesRoute,
  lab_resultsRoute: lab_resultsRoute,
  loginRoute: loginRoute,
  operationsRoute: operationsRoute,
  patientsRoute: patientsRoute,
  patientsPatientIdRoute: patientsPatientIdRoute,
  pharmacyRoute: pharmacyRoute,
  prescriptionRoute: prescriptionRoute,
  radiologyRoute: radiologyRoute,
  referentialAldRoute: referentialAldRoute,
  referentialCim10Route: referentialCim10Route,
  referentialCnssRoute: referentialCnssRoute,
  referentialForfaitsRoute: referentialForfaitsRoute,
  referentialLoincRoute: referentialLoincRoute,
  referentialMedicationsRoute: referentialMedicationsRoute,
  referentialNgapRoute: referentialNgapRoute,
  referentialRulesRoute: referentialRulesRoute,
  referentialSnomedRoute: referentialSnomedRoute,
  securityKeysRoute: securityKeysRoute,
  securitySecretsRoute: securitySecretsRoute,
  socRoute: socRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
